<section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
  <p class="card-title">{{'background' | translation}}</p>
  <p class="card-subtitle">{{'backgroundDescription' | translation}} </p>

  <div class="action-wrapper">
    <mat-form-field>
      <mat-label>{{'selectConfigActionType' | translation}}</mat-label>
      <mat-select [(value)]="config.action.type" (selectionChange)="saveChange()" required>
        <mat-option value="default">Aucun</mat-option>
        <mat-option value="time">Heures</mat-option>
      </mat-select>
    </mat-form-field>




    <div *ngIf="config.action.type == 'time'" class="timePickerContainer">
      <div class="startTimeContainer">


        <mat-form-field>
          <mat-label>{{'startTime' | translation}}</mat-label>
          <input matInput (ngModelChange)="saveChange()" [ngxTimepicker]="pickerStart" [format]="24" [max]="config.action.config.endTime" readonly [(ngModel)]="config.action.config.startTime">
        </mat-form-field>
        <ngx-material-timepicker #pickerStart></ngx-material-timepicker>
      </div>

      <div>
        <mat-form-field>
          <mat-label>{{'endTime' | translation}}</mat-label>
          <input matInput (ngModelChange)="saveChange()" [ngxTimepicker]="pickerEnd" [format]="24" [min]="config.action.config.startTime" [(ngModel)]="config.action.config.endTime" readonly>
        </mat-form-field>
        <ngx-material-timepicker #pickerEnd></ngx-material-timepicker>
      </div>


    </div>

  </div>





  <!-- FOND D'ECRAN THUMBNAIL -->
  <div class="thumbnail-wrapper">


    <div matRipple
         [matMenuTriggerFor]="menu"
         *ngFor="let img of config.listBackground; let i = index"
         class="thumbnail-content"
         fxLayout="column" fxLayoutAlign="space-around center">

      <!-- <button class="button-icon" mat-button [matMenuTriggerFor]="menu">
        <mat-icon>settings</mat-icon>
      </button> -->
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="setActiveBackground(img)">{{'activate' | translation }}</button>
        <button mat-menu-item (click)="removeBackground(img.url)"> {{'delete' | translation }}</button>
      </mat-menu>

      <span class="badge" *ngIf="img.url == config.activeBackground.url" matBadge="✔" matBadgeOverlap="true"></span>

      <!-- <i *ngIf="img == sharedService.configForm.backgroundURL " class="material-icons" id="activeBackground">
        done
      </i> -->
      <!-- IF IS AN IMAGE -->
      <img *ngIf="(img.name | mapFileName) == 'jpg' || (img.name | mapFileName) == 'png'"
           class="image-thumbnail thumbnail"
           [src]="img.url" poster="" />
      <!-- IF IS A VIDEO -->
      <div fxLayout="column" fxLayoutAlign="center center" class="video-thumbnail thumbnail"
           *ngIf="(img.name | mapFileName) == 'video'">
        <mat-icon>video_library</mat-icon>

      </div>

      <!-- TITLE -->
      <p class="overflow-ellipsis thumbnail-label"
         [style.font-size.px]="stylingService.getFontSize('small')"
         *ngIf="sharedService.urlToNameArray[i] != undefined">{{getNameFromUrl(img)}}</p>


    </div>


  </div>

  <button class="card-button" mat-flat-button color="primary" (click)="onUploadImage()">
    {{ 'importBackground' | translation }}
  </button>

  <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
    <div class="form-group" id="galleryEnable">
      <mat-slide-toggle color="accent" type="checkbox" (change)="saveChange()" name="galleryEnable"
                        [(ngModel)]="config.slideshow.active">
        {{'activateSlideshow' | translation}}
      </mat-slide-toggle>
    </div>

    <div *ngIf="config.slideshow.active">
      <mat-form-field autocomplete="off">
        <input matInput placeholder="Délai de transition (en sec)" (change)="saveChange()" type="number"
               [(ngModel)]="config.slideshow.time" matInputclass="form-control" id="timerSlideshow"
               name="timerSlideshow">
      </mat-form-field>
    </div>

  </section>


  <div>
    <section class="card-section">
      <p class="card-title">{{'activate' | translation}}</p>
      <!-- <p class="card-data">Une seule participation par utilisateur</p>-->
      <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="config.active" (ngModelChange)="saveChange()">
      </mat-slide-toggle>
      <!-- <mat-divider [inset]="true"></mat-divider> -->
    </section>
  </div>

  <div>
    <button class="card-button" mat-raised-button color="warn" (click)="deleteConfig()"><mat-icon>delete</mat-icon></button>

  </div>

</section>
